import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import { gapi } from "gapi-script";
// import { clienId } from "../Login/globalMethods";
import { Container, Accordion, ListGroup, Row, Col } from "react-bootstrap";
import "../../assets/css/profile.css";
import { IoIosArrowForward } from "react-icons/io";
import { GrFormAdd } from "react-icons/gr";
import { TbCurrencyRupee } from "react-icons/tb";
import UserLogout from "../Login/userLogout";
import { AddressForm } from "../Forms/addressForm";
import { userInfo } from "../../utils/appInfo";
import NotificationMsg from "../Notification";
import { SERVER_PATH } from "../../config/env";
import { ToastContainer } from "react-toastify";
import apiClient from "../../utils/api";

export default function Profile() {
  const [data, setData] = useState([]);
  const [state, setState] = useState("profile");
  const [formData, setFormData] = useState(false);
  const [userData, setUserData] = useState(false);

  const showForm = (clickData) => {
    setFormData(clickData);
  };

  const eventHandler = (clickState) => {
    setState(clickState);
  };

  const fetchData = async () => {
    await apiClient
      .post(`get/order.php`, {
        user_id: userData.email,
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [addressData, setAddressData] = useState([]);

  const addressFetchData = async () => {
    await apiClient
      .post(`get/user.php`, {
        user_id: userData.email,
      })
      .then((res) => {
        setAddressData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    setTimeout(() => {
      setUserData(userInfo());
      window.scrollTo(0, 0);
      // fetchData();
    }, 1000);

    // function start() {
    //   gapi.client.init({
    //     clientId: clienId,
    //     scope: "email",
    //   });
    // }
    // gapi.load("client:auth2", start);
  }, []);

  return (
    <>
      <Container fluid className="productPage">
        <div className="main-body">
          <div className="row gutters-sm">
            <div className="col-md-4 mb-3 ">
              <div className="card shadow-sm">
                <div className="cards-body-new">
                  <div
                    className="d-flex flex-column align-items-center text-center "
                    style={{ marginTop: "10%" }}
                  >
                    <img
                      src={
                        userData.picture
                          ? userData.picture
                          : "https://bootdey.com/img/Content/avatar/avatar7.png"
                      }
                      alt="profile"
                      className="rounded-circle"
                      width="150"
                    />
                    <div className="mt-3">
                      <h4 className="prof-name">{userData.name}</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card mt-3">
                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header className="">
                      Account Information
                    </Accordion.Header>
                    <Accordion.Body>
                      <ListGroup>
                        <ListGroup.Item
                          onClick={() => eventHandler("profile")}
                          className="information-text"
                        >
                          <IoIosArrowForward />
                          Profile Information
                        </ListGroup.Item>
                        <ListGroup.Item
                          onClick={() => {
                            eventHandler("address");
                            addressFetchData();
                          }}
                          className="information-text"
                        >
                          <IoIosArrowForward />
                          Address Information
                        </ListGroup.Item>
                        <ListGroup.Item
                          onClick={() => {
                            eventHandler("myOrders");
                            fetchData();
                          }}
                          className="information-text"
                        >
                          <IoIosArrowForward />
                          My Orders
                        </ListGroup.Item>
                        <ListGroup.Item
                          onClick={() => eventHandler("notifocation")}
                          className="information-text"
                        >
                          <IoIosArrowForward />
                          Notifications
                        </ListGroup.Item>
                      </ListGroup>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
            <div className="col-md-8">
              <div className="card mb-3">
                {state === "profile" ? (
                  <div className="cards-body-new detailsDiv m-3">
                    <Row>
                      <div className="mb-4 d-flex align-items-center">
                        <span className="h4 information-text-head">
                          Profile Details
                        </span>
                        {/* <span className="btn" style={{ color: "blue" }}>
                          Edit
                        </span> */}
                      </div>
                    </Row>
                    <Row>
                      <div className="col-sm-3">
                        <h6 className="mb-0 information-text-1">Username</h6>
                      </div>
                      <div className="col-sm-9 text-secondary">
                        <input
                          type="text"
                          placeholder={userData.name}
                          disabled
                          tyle={{ width: "100%" }}
                          className="information-text-1"
                        />
                      </div>
                    </Row>
                    <hr />
                    <Row>
                      <div className="col-sm-3">
                        <h6 className="mb-0 information-text-1">Email</h6>
                      </div>
                      <div className="col-sm-9 text-secondary">
                        <input
                          type="email"
                          placeholder={userData.email}
                          disabled
                          style={{ width: "100%" }}
                          className="information-text-1"
                        />
                      </div>
                    </Row>
                    <hr />
                    <Row>
                      <div className="col-sm-12">
                        <UserLogout className="information-text-1" />
                      </div>
                    </Row>
                  </div>
                ) : state === "address" ? (
                  <div className="cards-body-new addressDiv p-2">
                    <Row>
                      <div>
                        <h4 className="mb-3 rupees-size">Manage Addresses</h4>
                        <div>
                          <button
                            className="d-flex align-items-center rupees-size"
                            onClick={() => showForm(true)}
                          >
                            <GrFormAdd className="rupees-size" />
                            Add new address
                          </button>
                          {formData && (
                            <AddressForm
                              hide={() => showForm(false)}
                              addressData={addressFetchData}
                            />
                          )}
                          <hr style={{ color: "#000" }} />
                          <h4 className="mb-3 rupees-size">My Address</h4>
                          <div>
                            {addressData.map((d, i) => {
                              return d.state == "0" ? (
                                <h4 className="rupees-size">
                                  Enter your address
                                </h4>
                              ) : (
                                <address>
                                  <p className="mb-0 rupees-size">
                                    {d.user_name},
                                  </p>
                                  <p className="mb-0 rupees-size">
                                    {d.mobile_no},
                                  </p>
                                  <p className="mb-0 rupees-size">
                                    {d.address}
                                  </p>
                                  <p className="mb-0 rupees-size">{d.state}</p>
                                  <p className="mb-0 rupees-size">
                                    {d.pincode}
                                  </p>
                                </address>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </Row>
                  </div>
                ) : state === "myOrders" ? (
                  <div className="cards-body-new addressDiv p-2">
                    <Row>
                      <div>
                        <h4 className="mb-3 rupees-size">My Orders</h4>
                        <hr color="#e0e0e0" />
                        <Col
                          className="mb-3 shadow-none"
                          style={{ maxHeight: "400px", overflowY: "scroll" }}
                        >
                          {data.map((d) => {
                            return (
                              <>
                                <div
                                  className="cards-body-new mb-2 d-none d-sm-block"
                                  style={{
                                    borderColor: "#e0e0e0",
                                    borderStyle: "solid",
                                    borderWidth: "1px",
                                  }}
                                >
                                  <div className="d-flex justify-content-between">
                                    <div className="d-flex flex-row align-items-center">
                                      <div
                                        style={{ width: "65px" }}
                                        className="d-none d-sm-block"
                                      >
                                        <Link
                                          to={`/product/${d.product_id}`}
                                          className="text-decoration-none"
                                        >
                                          <img
                                            src={d.img1}
                                            className="img-fluid"
                                            alt=""
                                            style={{
                                              width: "65px",
                                              height: "50px",
                                              objectFit: "cover",
                                            }}
                                          />
                                        </Link>
                                      </div>
                                      <div
                                        className="ms-3"
                                        style={{ width: "180px" }}
                                      >
                                        <Link
                                          to={`/product/${d.product_id}`}
                                          className="text-decoration-none text-dark rupees-size"
                                        >
                                          <h6 className="text-uppercase rupees-size">
                                            {d?.product_name}
                                            <small
                                              className="text-secondary ms-1 rupees-size-1"
                                              style={{ fontSize: "12px" }}
                                            >
                                              {d?.weight}Gms
                                            </small>
                                          </h6>
                                          <p className="small mb-0 text-uppercase text-secondary">
                                            {d?.category}
                                          </p>
                                        </Link>
                                      </div>
                                    </div>
                                    <div className="d-flex flex-row align-items-center">
                                      <div>
                                        <h6 className="rupees-size-1">
                                          Status
                                        </h6>
                                        <p className="small mb-0 rupees-size-1">
                                          {d?.status}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="d-flex flex-row align-items-center">
                                      <div style={{ width: "80px" }}>
                                        <h5 className="rupees-size-1">
                                          {d?.quantity}
                                        </h5>
                                        <p className="small mb-0 rupees-size-1">
                                          Qty
                                        </p>
                                      </div>
                                      <div style={{ width: "100px" }}>
                                        <h5 className="mb-0 rupees-size-1">
                                          <TbCurrencyRupee
                                            style={{ marginTop: "-3px" }}
                                          />
                                          {d.offer_price * d.quantity}
                                        </h5>
                                        <p className="small mb-0 text-center rupees-size-1">
                                          Price
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* mobile cart div */}
                                <div
                                  className="cards-body-new mb-2 d-block d-sm-none"
                                  style={{
                                    borderColor: "#e0e0e0",
                                    borderStyle: "solid",
                                    borderWidth: "1px",
                                  }}
                                >
                                  <div className="d-flex flex-row align-items-center">
                                    <div style={{ width: "75px" }}>
                                      <Link
                                        to={`/product/${d.product_id}`}
                                        className="text-decoration-none"
                                      >
                                        <img
                                          src={d.img1}
                                          className="img-fluid mb-3"
                                          alt=""
                                          style={{
                                            width: "65px",
                                            height: "50px",
                                            objectFit: "cover",
                                          }}
                                        />
                                      </Link>
                                    </div>
                                    <div style={{ width: "200px" }}>
                                      <Link
                                        to={`/product/${d.product_id}`}
                                        className="text-decoration-none text-dark"
                                      >
                                        <h5 className="text-uppercase">
                                          {d?.product_name}
                                          <small
                                            className="text-secondary ms-1"
                                            style={{ fontSize: "12px" }}
                                          >
                                            {d?.weight}Gms
                                          </small>
                                        </h5>
                                        <p className="small mb-3 text-uppercase text-secondary">
                                          {d?.category}
                                        </p>
                                      </Link>
                                    </div>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <div className="d-flex flex-row align-items-center">
                                      <div style={{ width: "100px" }}>
                                        <h6>Status</h6>
                                        <p className="small mb-0">
                                          {d?.status}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="d-flex flex-row align-items-center">
                                      <div style={{ width: "100px" }}>
                                        <h5>{d?.quantity}</h5>
                                        <p className="small mb-0">Qty</p>
                                      </div>
                                      <div style={{ width: "80px" }}>
                                        <h5 className="mb-0">
                                          <TbCurrencyRupee
                                            style={{ marginTop: "-3px" }}
                                          />
                                          {d.offer_price * d.quantity}
                                        </h5>
                                        <p className="small mb-0 text-center">
                                          Price
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            );
                          })}
                        </Col>
                      </div>
                    </Row>
                  </div>
                ) : (
                  <div className="cards-body-new addressDiv p-2">
                    <Row>
                      <div>
                        <h4 className="mb-3 rupees-size">Notifications</h4>
                        <hr color="#e0e0e0" />
                        <NotificationMsg className="rupees-size" />
                      </div>
                    </Row>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Container>
      <ToastContainer />
    </>
  );
}
